import "../Affiliates.scss";
import React from "react";
import DateDropDown from "../../../SharedComponents/DateDropDown/DateDropDown";
import { useSelector, useDispatch } from "react-redux";
import AffiliatesController from "../AffiliatesController";
import AffiliateIndex from "./AffiliatesPanel";
import { wtpDisableMessage } from "components/AFP/Constants";
import Alert from "components/Alert";

const AffiliatesTile = (props) => {
	const dateDropDownValues = ['Prev 7 Days', 'Prev 14 Days', 'Prev 28 Days', 'This Month', 'Last Month'];
	const dispatch = useDispatch();
	const {afp_status, wtp_status } = useSelector(state => state?.detectModes?.data);
	const affiliatesData = useSelector(state => state.sessionAffiliates.data);
	const [value, setValue] = React.useState({
		graph: null,
		timeRange: null
	});
	const [graph, setGraph] = React.useState(null);

	React.useLayoutEffect(() => {
		document.body.style.backgroundColor = "rgba(244, 244, 244, 1)"
	}, []);

	React.useEffect(() => {
		if (value.graph !== "Affiliate Overview") {
			setValue({
				graph: "Affiliate Overview",
				timeRange: affiliatesData?.timeRange ?? 'Prev 7 Days'
			});
		} else {
			if (value.timeRange !== affiliatesData?.timeRange) {
				props.setLoading(true)
				Promise.resolve(
					AffiliatesController({ timeRange: value?.timeRange }, dispatch)
				).then(() => {
					props.setLoading(false);
				}).catch((e) => {
					props.setLoading(false);
				})
			}
		}
	}, [value]);


	const graphSelect = () => {
		switch (props.graph) {
			case 'Affiliate Overview':
				return <AffiliateIndex loading={props.loading} />
			default:

				return <></>
		};
	};
	React.useEffect(() => {
		setGraph(graphSelect());
	}, [props.loading, value]);
	
	if (afp_status === "off" && wtp_status === "off" && affiliatesData?.timeRange === "Prev 7 Days") {
		return (
			<>
			<Alert message={wtpDisableMessage} />
				<div className="button-box" style={{justifyContent:"right", marginTop:"2rem", marginRight:"2rem"}}>
					<div className="date-dropdown-container">
						<DateDropDown setValue={setValue} value={value} dateDropDownValues={dateDropDownValues} />
					</div>

				</div>
			</ >
			
		)
	};
	return (
		<div
			className="graph-tile"
			style={{ width: '95%' }}
		>
			<div className="graph-tile-header">
				<h2>{props.graph}</h2>
				<div className="button-box">
					<div className="date-dropdown-container">
						<DateDropDown setValue={setValue} value={value} dateDropDownValues={dateDropDownValues} />
					</div>

				</div>
			</div>
			<div className="graph-body">
				{graph}
			</div>
		</div>
	);
};

export default AffiliatesTile;